<template>
  <v-container fluid pa-0 ma-0>
    <v-layout :id="'printable-schedule-' + transaction.tracking_id" hidden-screen-only>
      <v-container fill-height pa-0 ma-0>
        <v-layout row wrap>
<div style="margin: auto;font-size: 16px;line-height: 24px;font-family: 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;color: #555;">
<table cellpadding="0" cellspacing="0" style="width: 100%;line-height: inherit;text-align: left;">

<tr>
<td colspan="2" style="font-size: 12px;line-height: 12px;padding-bottom: 10px;text-align: center;">
<font color="#44A9E2">
<div v-if="transaction.account_receipt_header_1">{{ transaction.account_receipt_header_1 }}</div>
<div v-if="transaction.account_receipt_header_2">{{ transaction.account_receipt_header_2 }}</div>
<div v-if="transaction.account_receipt_header_3">{{ transaction.account_receipt_header_3 }}</div>
</font>
</td>
</tr>

<tr class="top">
<td colspan="2" style="padding: 5px;vertical-align: top;">
<table style="width: 100%;line-height: inherit;text-align: left;">
<tr>
<td class="title" style="padding: 5px;vertical-align: top;padding-bottom: 20px;font-size: 45px;line-height: 45px;color: #333;">
<div v-if="transaction.account_logo">
<img :src="imageUrl + '/' + transaction.account_logo" style="width:100%; max-width:242px;" />
</div>
</td>
<td style="padding: 5px;vertical-align: top;text-align: right;padding-bottom: 20px;">
<h1>INSTALLMENT SCHEDULE</h1>
</td>
</tr>
</table>
</td>
</tr>

<tr class="information">
<td colspan="2" style="padding: 5px;vertical-align: top;">
<table style="width: 100%;line-height: inherit;text-align: left;">
<tr>
<td style="padding: 5px;vertical-align: top;padding-bottom: 40px;">
<h3>Please keep this schedule for your records.</h3><br>
<b><font color="#44A9E2">Billing Details</font></b><br>
<span v-if="transaction.billing_name">{{ transaction.billing_name }}<br></span>
<span v-if="transaction.billing_address">{{ transaction.billing_address }}<br></span>
<span v-if="transaction.billing_city || transaction.billing_state || transaction.billing_postal_code"><span v-if="transaction.billing_city">{{ transaction.billing_city }},</span> {{ transaction.billing_state }} {{ transaction.billing_postal_code }}<br></span>
<span v-if="transaction.billing_country">{{ transaction.billing_country }}</span>
</td>

<td style="padding: 5px;vertical-align: top;text-align: right;padding-bottom: 40px;">
<b><font color="#44A9E2">Merchant</font></b><br>
{{ transaction.account_name }}<br>
{{ transaction.account_street_1 }}<br>
<span v-if="transaction.account_street_2">{{ transaction.account_street_2 }}<br></span>
{{ transaction.account_city }}, {{ transaction.account_state }} {{ transaction.account_zip }}<br>
<span v-if="transaction.account_phone">{{ phone(transaction.account_phone) }}<br></span>
<span v-if="transaction.account_email">{{ transaction.account_email }}</span>
<br>&nbsp;<br>
<span v-if="transaction.customer_po">Customer PO: {{ transaction.customer_po }}<br></span>
<span v-if="transaction.custom_field_1">{{ transaction.custom_field_1 }}<br></span>
<span v-if="transaction.custom_field_2">{{ transaction.custom_field_2 }}<br></span>
<span v-if="transaction.custom_field_3">{{ transaction.custom_field_3 }}<br></span>

</td>
</tr>
</table>
</td>
</tr>

<tr>
<td colspan="2">
<table style="margin-left: auto; margin-right: auto;white-space:nowrap;width:90%;">

<tr class="item">
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;width: 100%;">
Total Amount:
</td>
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;">
{{ money(custom.total_amount / 100) }}
</td>
</tr>

<template v-if="downpayment">
<tr class="item">
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;width: 100%;">
Downpayment:
</td>
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;">
{{ money(downpayment.total_amount / 100) }} <span v-if="transaction.fee_amount">*</span>
</td>
</tr>
</template>

<tr class="item">
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;width: 100%;">
Payment Frequency:
</td>
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;">
{{ capitalize(transaction.recurring_type) }}
</td>
</tr>

<tr class="item">
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;width: 100%;">
No. of Payments:
</td>
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;">
{{ paymentcount }}
</td>
</tr>

<tr class="item">
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;width: 100%;">
Start Date:
</td>
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;">
{{ dateUtc(transaction.recurring_start) }}
</td>
</tr>

<tr class="item">
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;width: 100%;">
Installment:
</td>
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;">
{{ money(transaction.total_amount / 100) }} x {{ (final && Object.keys(final).length) ? (paymentcount - 1) : paymentcount }} <span v-if="transaction.fee_amount">*</span>
</td>
</tr>

<template v-if="final && Object.keys(final).length">
<tr class="item">
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;width: 100%;">
Final Payment:
</td>
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;">
{{ money(final.total_amount / 100) }} <span v-if="transaction.fee_amount">*</span>
</td>
</tr>
</template>

<tr class="item">
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;width: 100%;">
End Date:
</td>
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;">
  <template v-if="final && Object.keys(final).length">
    {{ dateUtc(final.future_post) }}
  </template>
  <template v-else>
    {{ dateUtc(transaction.recurring_end) }}
  </template>
</td>
</tr>

</table>
</td>
</tr>

<tr v-if="transaction.fee_amount">
<td colspan="2" style="font-size: 12px;line-height: 12px;padding-top: 10px;text-align: center;">
* Price Adjustment Fees have been added.
</td>
</tr>

</table>

<div style="bottom: 0;margin: 10px;position: absolute;width: 100%;">
<table cellpadding="0" cellspacing="0" style="width: 100%;line-height: inherit;text-align: center;">
<tr>
<td style="font-size: 12px;line-height: 12px;padding-top: 50px;text-align: center;">
<font color="#44A9E2">
<div v-if="transaction.account_receipt_footer_1">{{ transaction.account_receipt_footer_1 }}</div>
<div v-if="transaction.account_receipt_footer_2">{{ transaction.account_receipt_footer_2 }}</div>
<div v-if="transaction.account_receipt_footer_3">{{ transaction.account_receipt_footer_3 }}</div>
</font>
</td>
</tr>
</table>
</div>

</div>
        </v-layout>

      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import { Printd } from 'printd'

import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin, StoreMixin],

  data: function () {
    return {
      enabled: false,
      imageUrl: process.env.VUE_APP_IMAGE_URL || 'https://paynetworx-dev-images.s3.us-west-2.amazonaws.com'
    }
  },

  props: {
    transaction: Object,
    downpayment: Object,
    final: Object,
    paymentcount: Number,
    custom: Object

  },

  mounted () {
    if (process.env.NODE_ENV === 'production') {
      this.imageUrl = process.env.VUE_APP_IMAGE_URL || 'https://paynetworx-images.s3.us-west-2.amazonaws.com'
    }
  },

  methods: {
    print () {
      // handle page title change which is used for 'save as pdf'
      const printCallback = ({ launchPrint }) => {
        document.title = 'ACH Authorization'
        launchPrint()
      }
      const printd = new Printd()
      printd.print(document.getElementById('printable-schedule-' + this.transaction.tracking_id), [], [], printCallback)
    },
    email () {},
    save () {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/plans/SchedulePrint.vue